import React from 'react';
import { Building2, Settings2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const CompanySwitcher = ({ lang, companies, value, onChange, maxCompanies, onManage }) => {
  const ar = lang === 'ar';
  if (!companies?.length) return null;
  const single = companies.length <= 1 && maxCompanies <= 1;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="company-switcher-bar">
      <div className="text-xs text-[#111827]/60 dark:text-slate-400 flex items-center gap-1"><Building2 className="w-3.5 h-3.5" /> {ar ? 'الشركة:' : 'Company:'}</div>
      {single ? (
        <span className="h-9 inline-flex items-center px-3 rounded-md bg-white dark:bg-slate-800 border border-[#e5e7eb] dark:border-slate-700 text-sm font-semibold text-[#0a0a0a] dark:text-white" data-testid="company-switcher-single">{value}</span>
      ) : (
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger className="w-full sm:w-56 h-9 bg-white dark:bg-slate-800 border-[#e5e7eb] dark:border-slate-700 font-semibold" data-testid="company-switcher"><SelectValue /></SelectTrigger>
          <SelectContent>
            {companies.map((c) => (
              <SelectItem key={c.id} value={c.name} data-testid={`company-opt-${c.id}`}>
                {c.name}{c.is_default ? (ar ? ' · افتراضية' : ' · default') : ''}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {onManage && (
        <button onClick={onManage} className="h-9 px-2.5 inline-flex items-center gap-1 text-xs rounded-md border border-[#e5e7eb] dark:border-slate-700 bg-white dark:bg-slate-800 text-[#111827]/70 dark:text-slate-300 hover:text-[#2563eb] transition-colors" data-testid="company-manage-btn">
          <Settings2 className="w-3.5 h-3.5" /> {ar ? 'إدارة الشركات' : 'Manage'}
        </button>
      )}
    </div>
  );
};
